<script>
    import { scaleLinear } from 'd3-scale';
    export let details = {}

    const rescaleFunction = scaleLinear().domain([0,1209600]).range([0,600])
    const rescale = function(detail) {
        let day = detail["day"] - 6
        let cumulative_seconds = day*86400+detail["tod"]
        return rescaleFunction(cumulative_seconds)
    }
    const partOfDay = function(detail) {
        // <9am = morning
        // 11am - 3pm = noon
        // > 5pm = evening
        if ( detail["tod"] < 9*60*60 ) {
            return "morning"
        } else if ( 11*60*60 < detail["tod"] & detail["tod"] < 15*60*60 ) {
            return "noon"
        } else if ( 17*60*60 < detail["tod"] ) {
            return "evening"
        }
    }
</script>

<style>
    line {
        stroke: black;
        stroke-width: 1;
    }
    circle {
        fill: black;
        fill-opacity: 0.8;
        stroke: black;
        stroke-width: 0.5;
    }
    circle.morning {
        fill: #ffeda0;
    }
    circle.noon {
        fill: #feb24c;
    }
    circle.evening {
        fill: #f03b20
    }
    rect {
        stroke: none;
        fill-opacity: 0.2;
        fill: lightgrey;
    }
    rect.odd {
        fill: grey
    }
</style>

{#each Array.from(Array(14).keys()) as day}
    <rect class:odd={day %2 == 0}
        x={rescaleFunction(day*86400)} y=-5 width={rescaleFunction(86400)} height=15 />
{/each}
<line x1=0 x2=600 y1=0 y2=0 />
{#each details as detail}
    <circle class:morning={partOfDay(detail) == "morning"}
            class:noon={partOfDay(detail) == "noon"}
            class:evening={partOfDay(detail) == "evening"}
        cx={rescale(detail)} cy=0 r=3>
        <title>{detail["day"]} - {detail["time"]}</title>
    </circle>
{/each}